module.exports = __webpack_public_path__ + "static/media/pic9.72cb3022.jpg";